import { useEffect, useState } from 'react'
import { useLocalization } from '../../../localization'
import LanguageSelector from '../../../localization/LanguageSelector'

// Removed Spin, Title imports
import { useGlobalState } from '../../../store'

import { useNavigate } from 'react-router-dom'
// Added CBSpin import
import {
  CBButton,
  CBHeader,
  CBInput,
  CBList,
  CBListItem
} from '../../core/components/cbd'
import { CBSpin } from '../components/CBSpin'


import { ReactComponent as Connections } from '../../../images/svg/connections.svg'
import { ReactComponent as NewBooking } from '../../../images/svg/new-booking.svg'
import { ReactComponent as NewSync } from '../../../images/svg/new-sync.svg'

import momentTz from 'moment-timezone'
import SEO from '../../../components/SEO'
import Carat from '../../../images/arrow-right-chevron.png'
import { ReactComponent as HomeIcon } from '../../../images/svg/home.svg'
import { ReactComponent as Info } from '../../../images/svg/info.svg'
import { ReactComponent as SyncIcon } from '../../../images/svg/logo-syncing.svg'
import { ReactComponent as Trash } from '../../../images/svg/trash-delete.svg'

const MultiDropDownTest = ({ type = 'stuff', values, single = true }) => {
  const [value, setValue] = useState('')
  const [items, setItems] = useState([])
  return (
    <>
      <label for={type}>
        <CBInput
          id={`bong-${value}-${Math.random()}`}
          key={`test-${value == '' ? Math.random() : Math.random()}-ass`}
          list={type}
          name={type}
          type="text"
          value={value}
          onChange={(e) => {
            if (e) {
              if (values.indexOf(e) >= 0 && items.indexOf(e) == -1) {
                //console.log('ADD')
                if (!single) {
                  setValue('')
                } else {
                  setValue(e)
                }
                if (!single) {
                  setItems([...items, e])
                } else {
                  setItems([e])
                }
              } else if (items.indexOf(e) >= 0) {
                if (!single) {
                  setValue('')
                } else {
                  setValue(e)
                }
              } else {
                //console.log('WHAT')
              }
            }
          }}
        />
      </label>

      {!single && items.length > 0 && (
        <>
          {items.map((e) => (
            <CBListItem
              onClick={(q) => {
                var remove = items.filter((v) => v != e)
                setItems(remove)
              }}
              icon={<Trash></Trash>}
            >
              {e}
            </CBListItem>
          ))}
        </>
      )}
      <datalist id={type}>
        {values.map((v, i) => {
          return <option data-value={v} value={v}></option>
        })}
      </datalist>
    </>
  )
}
const CalendarTest = ({
  excludedDays = [],
  passDate,
  singleSelect = true,
  onSelect = (e) => console.log(e),
}) => {
  const [date, setDate] = useState(passDate || momentTz())
  const [dayOfMonth, setDayOfMonth] = useState(date.date())
  const [firstSelect, setFirstSelect] = useState(null)
  const [secondSelect, setSecondSelect] = useState(null)

  function generateDays() {
    const firstOfMonth = date.clone().date(1)
    const prevMonth = firstOfMonth.clone().month(firstOfMonth.month() - 1)
    const lastDayInMonth = date.clone().date(firstOfMonth.daysInMonth() - 1)
    const firstDayOfWeek = firstOfMonth.day()
    const lastDayOfWeek = lastDayInMonth.day()

    var daysInPrevMonth = prevMonth.daysInMonth()

    var dayArr = []
    var prevArr = []
    var postArr = []
    for (var j = 0; j < firstDayOfWeek; j++) {
      prevArr.unshift(daysInPrevMonth)
      daysInPrevMonth--
    }
    for (var i = 1; i <= date.daysInMonth(); i++) {
      dayArr.push(i)
    }
    var dayDiff = 7 - lastDayOfWeek - 1
    if (lastDayOfWeek == 6) {
      dayDiff = 7
    }
    if (lastDayOfWeek == 5) {
      dayDiff = 9
    }
    for (var k = 1; k < dayDiff; k++) {
      postArr.push(k)
    }
    return { pre: prevArr, days: dayArr, post: postArr }
  }
  const { pre, days, post } = generateDays(date)
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex justify-center gap-x-4 items-center">
        <CBButton
          type="qt"
          onClick={(e) => {
            setDate(date.clone().month(date.month() - 1))
          }}
        >
          {'<'}
        </CBButton>
        <span> {date.format('LL')}</span>
        <CBButton
          onClick={(e) => {
            setDate(date.clone().month(date.month() + 1))
          }}
          type="qt"
        >
          {'>'}
        </CBButton>
      </div>
      {/* <div>
        {firstSelect != null ? `Start: ${firstSelect.format('LL')}` : ''}{' '}
        {secondSelect != null ? ` End: ${secondSelect.format('LL')}` : ''}
      </div> */}
      <div className="grid grid-cols-7 gap-1 content-center w-1/2">
        {[
          t('common.day_initial.sun'),
          t('common.day_initial.mon'),
          t('common.day_initial.tue'),
          t('common.day_initial.wed'),
          t('common.day_initial.thu'),
          t('common.day_initial.fri'),
          t('common.day_initial.sat'),
        ].map((e) => {
          return <div className="text-neutral_4 p-1 text-center">{e}</div>
        })}
      </div>
      <div className="grid grid-cols-7 gap-1 w-1/2">
        {pre.map((e) => {
          return (
            <div
              onClick={(q) => {
                setDayOfMonth(e)
                setDate(
                  date
                    .clone()
                    .month(date.month() - 1)
                    .date(e)
                )
              }}
              className={`text-grey text-center p-1 m-1`}
            >
              {e}
            </div>
          )
        })}
        {days.map((e) => {
          const cellDate = date.clone().date(e)
          return (
            <div
              onClick={(q) => {
                setDayOfMonth(e)
                setDate(cellDate)
                onSelect(cellDate)
                if (!singleSelect) {
                  if (secondSelect != null) {
                    setFirstSelect(cellDate)
                    setSecondSelect(null)
                  } else if (
                    firstSelect != null &&
                    (cellDate.isSame(firstSelect) ||
                      cellDate.isAfter(firstSelect))
                  ) {
                    setSecondSelect(cellDate)
                  } else if (firstSelect == null) {
                    setFirstSelect(cellDate)
                  }
                }
              }}
              className={`
              ${
                singleSelect && cellDate.isSame(date)
                  ? 'bg-neutral_4 text-white hover:bg-neutral_4'
                  : ''
              }

              ${
                cellDate.isSame(firstSelect) || cellDate.isSame(secondSelect)
                  ? 'bg-neutral_4 text-white'
                  : ''
              } ${
                cellDate.isAfter(firstSelect) && cellDate.isBefore(secondSelect)
                  ? 'bg-neutral_2'
                  : ''
              } bg-neutral_1 hover:bg-neutral_2 text-neutral_4 text-center p-1 m-1 ${
                dayOfMonth == e ? 'bg-neutral_2 text-white' : ''
              } 
              ${
                excludedDays.includes(date.format('YYYY-MM-DD')) && 'text-gray'
              }`}
            >
              {e}
            </div>
          )
        })}{' '}
        {post.map((e) => {
          return (
            <div
              onClick={(q) => {
                setDayOfMonth(e)
                setDate(
                  date
                    .clone()
                    .month(date.month() + 1)
                    .date(e)
                )
              }}
              className={`text-grey text-center p-1 m-1`}
            >
              {e}
            </div>
          )
        })}
      </div>
    </div>
  )
}
const DropDownTest = () => {
  const [open, setOpen] = useState(false)
  const [selectedText, setSelectedText] = useState('')
  const { t } = useLocalization()

  return (
    <div className="flex flex-col w-32">
      <div
        id="toggle"
        className="flex flex-col bg-neutral_1 text-neutral_4 p-3 shadow-inner"
        onClick={(e) => {
          setOpen(!open)
        }}
      >
        {' '}
        {selectedText != '' ? (
          selectedText
        ) : (
          <div className="text-neutral_2">{t('home.select_item')}</div>
        )}
      </div>

      {open ? (
        <div id="items" className="absolute bg-neutral_1 overflow-auto">
          <div
            onClick={(e) => {
              setSelectedText('Item aaa')
              setOpen(false)
            }}
            className="hover:bg-neutral_2 p-3 cursor-pointer block flex-grow relative w-32"
          >
            Item aaa
          </div>
          <div
            onClick={(e) => {
              setSelectedText('Item 2')
              setOpen(false)
            }}
            className="hover:bg-neutral_2 p-3 cursor-pointer block flex-grow w-32"
          >
            Item qqqq
          </div>
          <div
            onClick={(e) => {
              setSelectedText('Item 3')
              setOpen(false)
            }}
            className="hover:bg-neutral_2 p-3 cursor-pointer block w-32"
          >
            Item 3
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

const HomePage = () => {
  const navigate = useNavigate()
  const [schedules] = useGlobalState('schedules')
  const [accounts] = useGlobalState('accounts')
  const [syncs] = useGlobalState('syncs')
  const [license] = useGlobalState('license')
  const { t } = useLocalization()

  const [bgError] = useGlobalState('errors')
  const [hasErrors, setHasErrors] = useState(false)
  const [hasSyncErrors, setHasSyncErrors] = useState(false)
  const [hasAccountErrors, setHasAccountErrors] = useState(false)
  const [vally, setVally] = useState('testing')
  const [shrink, setShrink] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [url, setUrl] = useState(null)

  useEffect(() => {
    var hasAccountErrors =
      accounts.filter((account) => account.errorState != '').length > 0
    var hasSyncErrors =
      syncs.filter(
        (sync) => sync.status == 'synced_error' && !sync.errorState.includes('null') 
      ).length > 0
    setHasAccountErrors(hasAccountErrors)
    setHasSyncErrors(hasSyncErrors)
    setHasErrors(hasAccountErrors || hasSyncErrors)
  }, [accounts, syncs])

  function onSelect(selectedList, selectedItem) {}

  function onRemove(selectedList, removedItem) {}

  return (
    <div className="cb-content-frame">
      <SEO title={t('home.dashboard_home')} />
      <div className="cb-content-pane mobile_padding min-h-screen">
        <div className="mb-6">
            <CBHeader
              label={t('home.home')}
              icon={<HomeIcon></HomeIcon>}
              buttonLabel={t('home.help')}
              buttonIcon={<Info></Info>}
              buttonAction={(e) => {
                window.open('https://help.calendarbridge.com/', '_blank')
              }}
            ></CBHeader>
            
        </div>
        {/* <CBCalendar excludedDays={["2021-09-15"]}></CBCalendar> */}
        {/* <MultiDropDownTest values={momentTz.tz.names().map((tz) => tz)}></MultiDropDownTest> */}
        {hasErrors && (
          <div className="mb-8">
            <CBHeader label={t('home.issues')} icon={<Info></Info>}></CBHeader>
            {hasAccountErrors && (
              <>
                <div
                  className="main-grid-item hover:bg-neutral_1 mb-2 mt-2"
                  onClick={(e) => navigate('/dashboard/accounts/')}
                >
                  <div className="t3 flex flex-row gap-4 text-red-600">
                    <Connections></Connections>{t('home.account_issue')}
                  </div>
                </div>
              </>
            )}
            {hasSyncErrors && (
              <div
                className="main-grid-item hover:bg-neutral_1 mb-2"
                onClick={(e) => navigate('/dashboard/syncs/')}
              >
                <div className="t3 flex flex-row gap-4 text-red-600">
                  <SyncIcon></SyncIcon>{t('home.sync_issue')}
                </div>
              </div>
            )}
          </div>
        )}
        <div style={{ margin: '0 auto', paddingBottom: 16 }}>
          {license.orgAdmin ? (
            <div className="mb-2">
              <CBListItem
                borderLight={true}
                icon={<img src={Carat} style={{ float: 'right' }}></img>}
                onClick={(e) => navigate('/dashboard/organization')}
              >
                {t('home.manage_organization')}
              </CBListItem>
            </div>
          ) : (
            <></>
          )}
          {license.userId != null && accounts && accounts.length == 0 ? (
            <div>
              <div className="text-lg mb-2 text-center font-sarabun text-neutral_4">{t('home.start_here')}</div>
            <div
              className="main-grid-item hover:bg-neutral_1"
              onClick={(e) => navigate('/dashboard/accounts/new')}
            >
              
              <div className="t3 flex flex-row gap-4">
                <Connections></Connections> {t('home.add_calendars')}
              </div>
            </div>
            </div>
          ) : license.userId == null ? (
            <div style={{ minHeight: 400 }} className="main-grid-item">
              {bgError && bgError != '' ? (
                <div className="flex flex-col justify-center items-center gap-y-8 text-lg">
                  <div>{t('home.account_loading_issue')}</div>
                  <CBButton
                    onClick={(e) => {
                      if (window) {
                        
                        navigate('/dashboard/')
                      }
                    }}
                    className="cusor-pointer"
                  >
                    {t('home.retry')}
                  </CBButton>
                  <div>{t('common.or')}</div>
                  <CBButton
                    onClick={(e) => {
                      if (window) {
                        navigate('/dashboard/logout')
                      }
                    }}
                    className="cusor-pointer"
                  >
                    {t('home.logout_and_signin')}
                  </CBButton>
                  {/* <div>
                    If the issue persists please{' '}
                    <a
                      target="_blank"
                      href="https://help.calendarbridge.com/request-support/"
                    >
                      contact support
                    </a>
                  </div> */}
                </div>
              ) : (
                 // Replaced Spin with CBSpin
                 <CBSpin
                    spinning={true}
                    size="large"
                    
                  />
              )}
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-2">
              <div
                className="main-grid-item hover:bg-neutral_1"
                onClick={(e) => navigate('/dashboard/accounts/new')}
              >
                <div className="t3 flex flex-row gap-4">
                  <Connections></Connections> {t('home.add_calendars')}
                </div>
              </div>

              <div
                onClick={(e) => navigate('/dashboard/syncs/new')}
                className="main-grid-item hover:bg-neutral_1"
              >
                <div className="t3 flex flex-row gap-4">
                  <NewSync></NewSync> {t('home.create_sync')}
                </div>
              </div>

              {/* {true && (
                <div
                  className="main-grid-item hover:bg-neutral_1"
                  onClick={(e) => navigate('/dashboard/group/new')}
                >
                  <div className="t3 flex flex-row gap-4">
                    {' '}
                    <NewSchedule></NewSchedule>Create Booking
                  </div>
                </div>
              )} */}

              <div
                className="main-grid-item hover:bg-neutral_1"
                onClick={(e) => navigate('/dashboard/schedules/new')}
              >
                <div className="t3 flex flex-row gap-4 ">
                  {' '}
                  <NewBooking></NewBooking> {t('home.create_scheduler')}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <CBButton  onClick={e=>{
       navigate("/dashboard/accounts/new/")
     }} long={true} type="primary" icon={<Add style={{float:'right'}}></Add>}>Connect Calendar</CBButton> */}
        <div className="h-4"></div>
        {/* <CBCard style={{ borderWidth: '0px',marginBottom:48}} title="Syncing" icon={<img style={{marginBottom:4, marginRight:4}} src={SyncIcon} ></img>} rightAction="New Sync" footerContent={<div>Sync your calendars</div>} >
      </CBCard>  
    
      <CBCard style={{ borderWidth: '0px',marginBottom:48}} title="Scheduling" icon={<img style={{marginBottom:4, marginRight:4}} src={ScheduleIcon} ></img>} rightAction="New Invitation" footerContent={<div>Schedule a meeting</div>} >
      </CBCard>  
      <CBCard style={{ borderWidth: '0px',marginBottom:48}} title="Booking" icon={<BookingIcon style={{marginRight: 8, verticalAlign: 'middle'}}/>} rightAction="New Scheduler" footerContent={<div>Create a scheduling link</div>} >
      </CBCard>   */}
        {license.userId != null &&
          !license.trial &&
          license.referralCode != '' && (
            <>
              {/* <div className="flex flex-col items-center gap-1 justify-center p-4 border-2 border-neutral_1 rounded-sm mb-4 text-center"> */}
                {/* Replaced Title with h3 */}
                {/* <h3 className="inline text-xl font-semibold">
                  Give CalendarBridge. Get CalendarBridge.
                </h3> */}
                {/* <GiveGet className="md:pl-36 md:pr-36"></GiveGet>
                <div>
                  When someone signs up with your code, they get a free month
                  and you get a free month. <br /> Your code:
                </div>{' '} */}
                {/* Replaced Title with h5 + copy logic (or component) */}
                {/* <h5 className="inline text-sm font-semibold">
                  {license.referralCode}
                </h5>{' '} */}
                 {/* Add copy button if needed */}
                {/* <div>
                  <a href="dashboard/referrals">View Referral Program</a>
                </div>
              </div> */}
              <div className="flex flex-col hidden items-center gap-1 justify-center p-4 border rounded-sm mb-4 text-center">
                <div className="font-sarabun text-lg text-neutral_4 mb-4">
                  {t('home.love_calendarbridge')}<br />{t('home.help_spread_word')}
                </div>
                <div class="sharing-buttons grid grid-cols-1 md:grid-cols-3 ">
                  <a
                    class="border duration-200 ease inline-flex items-center mb-1 mr-1 transition py-1 px-2 text-sm rounded text-brand_dark_blue border- border-brand_blue bg-white hover:bg-blue-700 hover:border-brand_blue"
                    target="_blank"
                    rel="noopener"
                    href={
                      'https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fhelp.calendarbridge.com%2Fshare%2F' +
                      license.referralCode
                    }
                    aria-label={t('home.share_on_linkedin')}
                  >
                    <svg
                      aria-hidden="true"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      class="w-4 h-4"
                    >
                      <title>Linkedin</title>
                      <path d="M136 183v283H42V183h94zm6-88c1 27-20 49-53 49-32 0-52-22-52-49 0-28 21-49 53-49s52 21 52 49zm333 208v163h-94V314c0-38-13-64-47-64-26 0-42 18-49 35-2 6-3 14-3 23v158h-94V183h94v41c12-20 34-48 85-48 62 0 108 41 108 127z"></path>
                    </svg>
                    <span class="ml-1">{t('home.share_on_linkedin')}</span>
                  </a>
                  
                  
                  <a
                    class="border duration-200 ease inline-flex items-center mb-1 mr-1 transition py-1 px-2 text-sm rounded text-brand_dark_blue border- border-brand_blue bg-white hover:bg-blue-700 hover:border-brand_blue"
                    target="_blank"
                    rel="noopener"
                    href={
                      'https://twitter.com/intent/tweet?text=If%20you%20have%20calendars%20across%20multiple%20email%20addresses,%20you%20should%20check%20out%20CalendarBridge.com.%0AFinally%20an%20easy%20way%20to%20keep%20my%20availability%20accurate%20on%20all%20my%20calendars!%0A&url=https://help.calendarbridge.com/share/' +
                      license.referralCode
                    }
                    aria-label={t('home.share_on_twitter')}
                  >
                    <svg
                      aria-hidden="true"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      class="w-4 h-4"
                    >
                      <title>Twitter</title>
                      <path d="m459 152 1 13c0 139-106 299-299 299-59 0-115-17-161-47a217 217 0 0 0 156-44c-47-1-85-31-98-72l19 1c10 0 19-1 28-3-48-10-84-52-84-103v-2c14 8 30 13 47 14A105 105 0 0 1 36 67c51 64 129 106 216 110-2-8-2-16-2-24a105 105 0 0 1 181-72c24-4 47-13 67-25-8 24-25 45-46 58 21-3 41-8 60-17-14 21-32 40-53 55z"></path>
                    </svg>
                    <span class="ml-1">{t('home.share_on_twitter')}</span>
                  </a>

                  
                  <a
                    class="border duration-200 ease inline-flex items-center mb-1 mr-1 transition py-1 px-2 text-sm rounded text-brand_dark_blue border- border-brand_blue bg-white hover:bg-blue-700 hover:border-brand_blue"
                    target="_blank"
                    rel="noopener"
                    href={
                      'https://facebook.com/sharer/sharer.php?u=https://help.calendarbridge.com/share/' +
                      license.referralCode
                    }
                    aria-label={t('home.share_on_facebook')}
                  >
                    <svg
                      aria-hidden="true"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      class="w-4 h-4"
                    >
                      <title>Facebook</title>
                      <path d="M379 22v75h-44c-36 0-42 17-42 41v54h84l-12 85h-72v217h-88V277h-72v-85h72v-62c0-72 45-112 109-112 31 0 58 3 65 4z"></path>
                    </svg>
                    <span class="ml-1">{t('home.share_on_facebook')}</span>
                  </a>
                </div>
                <div className='grid-cols-1'>
                <div className="mb-2 mt-2">
                  {t('home.include_referral_code')} <br /> {t('home.your_code')}
                </div>{' '}
                {/* Replaced Title with h5 + copy logic */}
                <h5 className="inline text-sm font-semibold">
                  {license.referralCode}
                </h5>{' '}
                 {/* Add copy button if needed */}
                <div>
                  <br /><sup>1</sup><a href="https://help.calendarbridge.com/get-5-for-sharing-calendarbridge/">{t('home.social_sharing_terms')}</a>
                </div>
                <div><sup>2</sup><a href="dashboard/referrals">{t('home.referral_program_terms')}</a></div>
                </div>
              </div>
            </>
          )}
          <div className="flex flex-row justify-between"> <div
          style={{
            color: '#49515C',
            fontFamily: 'Sarabun',
            marginBottom: '8px',
          }}
        >
          {t('home.settings')}
        </div><LanguageSelector className="mb-4" />
          </div>
        
        <CBList borderLight={true}>
          <CBListItem
            borderLight={true}
            style={{ marginBottom: 8 }}
            onClick={(e) => {
              navigate('/dashboard/accounts/')
            }}
            type="list"
            icon={<img src={Carat} style={{ float: 'right' }}></img>}
          >
            {t('home.manage_accounts')}
          </CBListItem>
          <CBListItem
            borderLight={true}
            style={{ marginBottom: 8 }}
            onClick={(e) => {
              navigate('/dashboard/settings/')
            }}
            type="list"
            icon={<img src={Carat} style={{ float: 'right' }}></img>}
          >
            {t('home.manage_billing')}
          </CBListItem>
          {license.orgId == 'single' ? (
            <CBListItem
              borderLight={true}
              icon={<img src={Carat} style={{ float: 'right' }}></img>}
              onClick={(e) => navigate('/dashboard/organization/new')}
            >
              {t('home.create_organization')}
            </CBListItem>
          ) : (
            <></>
          )}
          <CBListItem
            borderLight={true}
            style={{ marginBottom: 8 }}
            onClick={(e) => {
              navigate('/dashboard/logout/')
            }}
            type="list"
            icon={<img src={Carat} style={{ float: 'right' }}></img>}
          >
            {t('home.logout')}
          </CBListItem>
        </CBList>
      </div>
    </div>
  )
}

const styles = {
  copyBlock: {
    display: 'inline-block',
    padding: 10,
    border: '1px solid #d9d9d9',
    borderRadius: 4,
    backgroundColor: '#fff',
    marginBottom: 20,
  },
}

export default HomePage
